import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAuth} from "firebase/auth";
import {getStorage} from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDQrP01AcOfwxA-H5DuNB4zQ0WSCZUQoQg",
    authDomain: "lorekeeper-6ffd8.firebaseapp.com",
    projectId: "lorekeeper-6ffd8",
    storageBucket: "lorekeeper-6ffd8.appspot.com",
    messagingSenderId: "756172030117",
    appId: "1:756172030117:web:ec05f593837155d5b78d4c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export {auth, db, storage};